import axios from 'axios';


//https://localhost:44348
const resolveBaseURL = () => {
  try {
    const { hostname, origin } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    return origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClientSurveys = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientSurveys.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClientSurveys.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default httpClientSurveys;

